import BetaFeatures from '../pages/BetaFeatures';

const BetaFeaturesRoutes = [
  {
    breadcrumb: [{ path: '/beta-features', breadcrumbName: 'Beta Features' }],
    Component: BetaFeatures,
  },
];

export default BetaFeaturesRoutes;
